import React, { useMemo } from "react";

export interface InfoPlateProps {
    className?: string
    children: React.ReactNode[] | React.ReactNode;
}

// Вспомогательная функция для генерирования уникальных ID
const generateItemId = (child: React.ReactNode, index: number): string => {
    if (typeof child === 'string') return `info-${child.substring(0, 20)}-${index}`;
    if (typeof child === 'number') return `info-num-${child}-${index}`;
    return `info-item-${index}`;
};

export const InfoPlate: React.FC<InfoPlateProps> = React.memo(({ children, className }) => {
    // Мемоизируем отрендеренные элементы
    const renderedItems = useMemo(() => {
        if (Array.isArray(children))
            return children.map((child, index) => (
                <React.Fragment key={generateItemId(child, index)}>
                    {child}
                    {index < children.length - 1 && <p />}
                </React.Fragment>
            ));
        else {
            return (
                <React.Fragment>
                    {children}
                    <p />
                </React.Fragment>
            );
        }
    }, [children]);

    return (
        <div className={'info-ui' + (className ? ' ' + className : '')}>
            {renderedItems}
        </div>
    );
});